import React, { useState, useEffect } from 'react';

import Sync from 'components/Icons/Sync';

import {
  OfflineSubmitSuccessContainer,
  OfflineSubmitSuccessText,
  SubmissionContainer,
  Overview,
  SyncIconContainer,
  MainContainer,
  ButtonWrapper,
  OfflineSubmitSuccessTitle,
} from 'containers/EntitiesFormPublicSubmission/styles';

import { Button } from 'components/Button';

import { Container as FormContainer } from 'containers/EntitiesFormSubmission/styles';

import { publicEventFormDB } from 'utils/indexedDB/publicEventFormDB';

import PublicSubmissionHeader from '../PublicSubmissionHeader';
import OfflineQueueModal from '../OfflineQueueModal';

const OfflineSuccessPage = (): React.ReactElement => {
  const [showQueueModal, setShowQueueModal] = useState(false);
  const [queueCount, setQueueCount] = useState(0);

  useEffect(() => {
    const loadQueueCount = async (): Promise<void> => {
      try {
        const count = await publicEventFormDB.getOfflineQueueCount();
        setQueueCount(count);
      } catch {
        // Ignore errors
      }
    };
    loadQueueCount();
  }, []);

  return (
    <MainContainer>
      <PublicSubmissionHeader hideOfflineNotification />
      <Overview>
        <SubmissionContainer>
          <FormContainer>
            <OfflineSubmitSuccessContainer>
              <SyncIconContainer>
                <Sync sx={{ width: '64px', height: '64px' }} />
              </SyncIconContainer>
              <OfflineSubmitSuccessTitle>Offline confirmation</OfflineSubmitSuccessTitle>
              <OfflineSubmitSuccessText>
                Your submission was saved and will be sent when you are back online
              </OfflineSubmitSuccessText>
            </OfflineSubmitSuccessContainer>
          </FormContainer>
          <ButtonWrapper>
            <Button fullWidth size="large" variant="outlined" onClick={() => setShowQueueModal(true)}>
              View Queue{queueCount > 0 ? ` (${queueCount})` : ''}
            </Button>
            <Button
              fullWidth
              size="large"
              variant="contained"
              onClick={() => {
                window.location.reload();
              }}
            >
              Report new event
            </Button>
          </ButtonWrapper>
        </SubmissionContainer>
      </Overview>
      <OfflineQueueModal open={showQueueModal} onClose={() => setShowQueueModal(false)} />
    </MainContainer>
  );
};

export default OfflineSuccessPage;
